import { Injector } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { NotificationService } from '../services/notification.service';

export abstract class BaseResolver {
  protected notificationService: NotificationService;

  constructor(private injector: Injector) {
    this.notificationService = this.injector.get(NotificationService);
  }

  protected handleError(message: string, error: any): Observable<any> {
    this.notificationService.error(message);
    return throwError(error);
  }
}
